"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styles_1 = require("./styles");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

function DisplayField(_a) {
  var label = _a.label,
      value = _a.value,
      labelProps = _a.labelProps,
      otherProps = __rest(_a, ["label", "value", "labelProps"]);

  return React.createElement("div", __assign({}, otherProps), React.createElement(FormFieldLabel, __assign({
    label: label
  }, labelProps)), React.createElement("div", __assign({}, styles_1.valueStyles), Array.isArray(value) ? value.map(function (str, i) {
    return React.createElement("div", {
      key: str + "-" + i
    }, str);
  }) : value));
}

exports.DisplayField = DisplayField;

function FormFieldLabel(_a) {
  var label = _a.label,
      otherProps = __rest(_a, ["label"]);

  return React.createElement("label", __assign({}, styles_1.labelStyles(colors_1.silverChalice), otherProps), label);
}

exports.FormFieldLabel = FormFieldLabel;